/**
 * Shared mutable scene refs. Mutated by HTML sections (via scroll/intersection),
 * read by the persistent <Scene3D /> camera rig on every frame.
 * Using a plain mutable object avoids React re-renders.
 */
export const sceneRefs = {
    /** 0..1 — how strongly the camera should focus on / zoom into the globe. */
    globeFocus: 0,
    /** Additional rotation boost while a showcase section is active. */
    globeBoost: 0,
};
